var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_6531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 46V39M24 46H18M24 46H30",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.51857,
    y1: 33.7633,
    x2: 42.2578,
    y2: 43.3396,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 29.5H12M17.5 29.5H12M12 29.5V35",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 36H37M42.5 36H37M37 36V42",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9036 30.3799C42.0968 23.8958 41.6881 14.4046 35.6774 8.39389C29.2282 1.94464 18.7719 1.94464 12.3226 8.39388C11.7603 8.9562 11.247 9.54898 10.7828 10.1669C7.96713 13.9145 6.95487 18.5872 7.74598 23",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.6667C21.2383 12.6667 19 14.1583 19 16C19 17.8417 21.2383 19.3333 24 19.3333C26.7617 19.3333 29 20.825 29 22.6667C29 24.5083 26.7617 26 24 26M24 12.6667V26M24 12.6667C25.85 12.6667 27.4667 13.3367 28.3317 14.3333M24 12.6667V11M24 26V27.6667M24 26C22.15 26 20.5333 25.33 19.6683 24.3333",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_6531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNim);
export default __webpack_public_path__ + "static/media/nim.a5dd59414fa278c2984b52924d781a3b.svg";
export { ForwardRef as ReactComponent };